import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CircularProgress from 'material-ui/CircularProgress';
import variables from '@chama/statics/stylesheets/variables';

import './index.css';

const spinnerProptypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  fill: PropTypes.bool,
  padded: PropTypes.bool,
  page: PropTypes.bool,
  size: PropTypes.number,
  thickness: PropTypes.number,
  color: PropTypes.string,
  style: PropTypes.object,
};

const spinnerDefaultProps = {
  className: null,
  children: '',
  size: 50,
  thickness: 4,
  color: variables.default['--chama-blue'],
  page: false,
  padded: false,
  fill: false,
  style: {},
};

const Spinner = ({ className, children, fill, padded, page, size, thickness, color, style }) => {
  const spinnerModifiers = {
    'Spinner--fill': fill,
    'Spinner--padded': padded,
    'Spinner--page': page,
  };

  return (
    <div style={style} className={classNames('Spinner', spinnerModifiers, className)}>
      <CircularProgress size={size} thickness={thickness} color={color} />
      <div className="Spinner-text">{children}</div>
    </div>
  );
};

Spinner.propTypes = spinnerProptypes;
Spinner.defaultProps = spinnerDefaultProps;

export default Spinner;



// WEBPACK FOOTER //
// ../ui-components/components/Spinner/index.jsx